<template>
  <div class="error">
    <div class="code">404</div>
    <div class="message">Page Not Found</div>
  </div>
</template>

<script lang="ts" src="./script.ts"></script>
<style lang="scss" src="./style.scss" scoped></style>
